var $785514c2f6c03dfa$exports = {};
(function() {
    window.addEventListener("load", (event)=>{
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://sdk.onfido.com/v14.24.0";
        document.body.appendChild(script);
    });
})();


//# sourceMappingURL=index.aeeef68a.js.map
